import React, { useId } from "react";
import SpeakerCard from "./SpeakerCard/SpeakerCard";
import "./Speakers.scss";
import { Row, Col } from "react-bootstrap";
import SpecialGuest from "./Assets/special-guest.png";
import SliderGrab from "../../../Components/SliderGrab/SliderGrab";
import CDLogo from "./Assets/cd-logo.png";
import ZixxarLogo from "./Assets/ZIXXAR-LOGO.png";
import GradientUnderline from "../../../Components/GradientUnderline/GradientUnderline";
import Emm from "./Assets/ema_v2.png";
import Chr from "./Assets/chrys.png";
import Ot from "./Assets/ovidiu.png";
import Raz from "./Assets/razlan.png";
import RNFLogo from "./Assets/rnf-logo.png";

const SPEAKERS = [
  {
    name: "Chrysanthos Alexandrou",
    position: "Director of Training - ZiXXar",
    photo: Chr,
    special: false,
    logo: ZixxarLogo,
  },
  {
    name: (
      <>
        Ovidiu <br /> Toma
      </>
    ),
    position: "Chief Executive Officer",
    photo: Ot,
    special: false,
    logo: CDLogo,
  },
  {
    name: (
      <>
        Emanuela <br /> Mitrea
      </>
    ),
    position: "Head of Marketing & PR",
    photo: Emm,
    special: false,
    logo: CDLogo,
  },
  {
    name: (
      <>
        Razlan <br /> Razali
      </>
    ),
    position: "Founder & Team Principal",
    photo: Raz,
    special: false,
    logo: RNFLogo,
    specialClass: "rnf-logo",
  },
  {
    name: "Special Invite",
    position: "",
    photo: SpecialGuest,
    special: false,
    logo: "",
  },
  {
    name: "Special Invite",
    position: "",
    photo: SpecialGuest,
    special: false,
    logo: "",
  },
  {
    name: "Special Invite",
    position: "",
    photo: SpecialGuest,
    special: false,
    logo: "",
  },
  {
    name: "TBA",
    position: "TBA",
    photo: SpecialGuest,
    special: true,
    logo: CDLogo,
  },
];

const Speakers = () => {
  const id = useId();

  return (
    <div
      id="event-speakers"
      className="section-margins"
      style={{ overflow: "hidden" }}
    >
      <div className="large-container d-flex align-items-center justify-content-center flex-column">
        <h2 className="font-pnb font-size-64">Speakers.</h2>
        <GradientUnderline />
        <span
          className="color-light-grey font-size-18 text-center mb-5 lh-1"
          style={{ maxWidth: "400px" }}
        >
          Hear from the Best in Business <br />
          Our Top-Notch speakers will inspire you and give you their knowledge
        </span>
        <div className="speakers-container w-100">
          <Row xs={1} sm={2} md={3} lg={4} className="gy-4 d-none d-lg-flex">
            {SPEAKERS.map((el, index) => {
              return (
                <React.Fragment key={id + index}>
                  <Col>
                    <SpeakerCard
                      name={el.name}
                      position={el.position}
                      photo={el.photo}
                      special={el.special}
                      logo={el.logo}
                    />
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>
          <div className="w-100 d-block d-lg-none">
            <SliderGrab>
              <div className="d-flex align-items-start justify-content-start gap-4">
                {SPEAKERS.map((el, index) => {
                  return (
                    <React.Fragment key={id + index}>
                      <SpeakerCard
                        name={el.name}
                        position={el.position}
                        photo={el.photo}
                        special={el.special}
                        logo={el.logo}
                      />
                    </React.Fragment>
                  );
                })}
              </div>
            </SliderGrab>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Speakers;
